import Grid from "@mui/material/Grid";
import { useSelector } from "react-redux";

import styles from "../../assets/css/pane.module.scss";
import Remittance from "./Remittance";
import RemittanceDashboardLeftPane from "./RemittanceDashboardLeftPane";
import RemittanceDashboardRightPane from "./RemittanceDashboardRightPane";

const RemittanceDashboard = () => {
  const { isMobileDevice } = useSelector((state) => state.app);
  if (isMobileDevice) {
    return (
      <Grid container>
        <div className={styles.mobileContainer}>
          <Remittance />
        </div>
      </Grid>
    );
  }
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
        <RemittanceDashboardLeftPane />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={7} xl={7}>
        <RemittanceDashboardRightPane>
          <Remittance />
        </RemittanceDashboardRightPane>
      </Grid>
    </Grid>
  );
};
export default RemittanceDashboard;
